// Formatea un importe junto con su código de moneda ISO (MXN, USD, EUR, GBP).
//
// Los helpers de app/components/utils/functions.js no sirven para esto:
// formatCurrency/formatCurrencyTwo están hechos para enmascarar lo que se
// escribe en un input, reciben string, descartan los decimales y asumen pesos.
export const formatAmount = (amount, currencyCode, lang = "es") => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "";

  const locale = lang === "en" ? "en-US" : "es-MX";

  try {
    // `currencyDisplay: "code"` en vez del simbolo. Con el simbolo, `Intl`
    // resuelve segun el locale y el mismo "$" significaba cosas distintas en
    // cada idioma: 5 MXN se leia "$5.00" en espanol y "MX$5.00" en ingles,
    // mientras 4.99 USD se leia "USD 4.99" en espanol y "$4.99" en ingles. Es
    // decir, en la portada de una tarjeta el "$" eran pesos en una interfaz y
    // dolares en la otra. Con el codigo salen "MXN 5.00" y "USD 4.99" iguales
    // en los dos, que es lo que pide CA-08 (la moneda visible antes de
    // confirmar) sin depender de que la persona sepa que locale esta viendo.
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currencyCode || "MXN",
      currencyDisplay: "code",
    }).format(value);
  } catch {
    // Intl lanza si el código de moneda no es ISO 4217 válido; el importe
    // sigue siendo útil aunque el código venga mal desde el backend.
    return `${value.toFixed(2)} ${currencyCode || ""}`.trim();
  }
};
